import { useLocalization } from '@lib/localization';
import { CardContent, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import { useUpdatePreferencesMutation } from '@store/api/authEndpoints';
import { useAppSelector } from '@store/hooks';
import { type ColorBlindnessType, selectCurrentTheme, setThemeType } from '@store/reducers/accessibilitySlice';
import { useDispatch } from 'react-redux';
import { CardDescription, CardHeader, CardTitle } from './Settings.styled';

const ColorBlindModeSelectorCard = () => {
  const dispatch = useDispatch();
  const currentTheme = useAppSelector(selectCurrentTheme);
  const { t } = useLocalization();
  const [updatePreferences] = useUpdatePreferencesMutation();

  // On screen at once and onto the account behind it, as the language card does.
  const handleChange = (value: string) => {
    const theme = value as ColorBlindnessType;
    dispatch(setThemeType(theme));
    updatePreferences({ colorBlindMode: theme });
  };

  const COLOR_BLIND_LABELS: Record<ColorBlindnessType, string> = {
    normal: t('Settings_ColorBlindMode_Normal'),
    protanopia: t('Settings_ColorBlindMode_Protanopia'),
    deuteranopia: t('Settings_ColorBlindMode_Deuteranopia'),
    tritanopia: t('Settings_ColorBlindMode_Tritanopia'),
    achromatopsia: t('Settings_ColorBlindMode_Achromatopsia'),
  };

  return (
    <Paper sx={{ mb: 2 }}>
      <CardHeader>
        <CardTitle variant="h6">{t('Settings_ColorBlindMode')}</CardTitle>
        <CardDescription variant="body2">
          {t('Settings_ColorBlindMode_Subtitle')}
        </CardDescription>
      </CardHeader>
      <CardContent style={{ padding: '24px' }}>
        <FormControl fullWidth size="small">
          <InputLabel id="color-blind-select-label">{t('Settings_ColorBlindMode_Select')}</InputLabel>
          <Select
            labelId="color-blind-select-label"
            value={currentTheme}
            onChange={(e) => handleChange(e.target.value)}
            label={t('Settings_ColorBlindMode_Select')}
          >
            {Object.entries(COLOR_BLIND_LABELS).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </CardContent>
    </Paper>
  );
};

export default ColorBlindModeSelectorCard;
